module.exports = __webpack_public_path__ + "img/xujingle.d7cb6316.png";